import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

/**
 * Shared primary-header styling for all app DataGrids.
 */
export const primaryHeaderSx = {
    '& .MuiDataGrid-columnHeader': {
        color: 'primary.contrastText',
        backgroundColor: 'primary.dark',
    },
    '& .MuiDataGrid-scrollbarFiller--header': {
        backgroundColor: 'primary.dark',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
    '& .MuiDataGrid-iconSeparator': {
        color: 'primary.contrastText',
    },
};

const defaultSlotProps = {
    pagination: {
        paginationModel: { pageSize: 25 },
    },
};

/**
 * Centralized DataGrid with primary header look and shared defaults.
 * Pass rows, columns, getRowId (if needed), and any overrides.
 */
export function StyledDataGrid({
    rows,
    columns,
    getRowId,
    sx = {},
    pageSizeOptions = [10, 25, 50],
    initialState,
    ...rest
}) {
    const alternatingRowSx = {
        '& .MuiDataGrid-row:nth-of-type(odd)': {
            backgroundColor: 'rgba(0, 0, 0, 0.02)',
        },
        '& .MuiDataGrid-row:nth-of-type(even)': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '& .MuiDataGrid-row:hover': {
            backgroundColor: 'rgba(25, 118, 210, 0.08)',
        },
        '& .MuiDataGrid-row.Mui-selected': {
            backgroundColor: 'rgba(25, 118, 210, 0.14) !important',
        },
        '& .MuiDataGrid-row.Mui-selected:hover': {
            backgroundColor: 'rgba(25, 118, 210, 0.2) !important',
        },
    };

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            getRowId={getRowId}
            autoHeight
            pageSizeOptions={pageSizeOptions}
            initialState={{
                pagination: { paginationModel: defaultSlotProps.pagination.paginationModel },
                ...initialState,
            }}
            disableRowSelectionOnClick
            sx={{ ...primaryHeaderSx, ...alternatingRowSx, ...sx }}
            {...rest}
        />
    );
}

export const dataGridCustomizations = {};
